import _ from "lodash";
import React from "react";

import { cn } from "@/lib/helpers/cn";
import { FormFieldContainer } from "@/component-library/FormFields/FormFieldContainer/FormFieldContainer";
import { FormTextArea } from "@/component-library/FormFields/FormTextArea/FormTextArea";
import { Text } from "@/component-library";

// Readonly mode should be handled by new form components but as a temporary measure
// this still uses subpar conditional rendering similar to AdvancedCareActivityInput

export function AdvancedCareActivityTextArea({
  className,
  formikProps,
  inputClassName,
  isDisabled,
  name,
  readOnly,
  resize,
  testId,
  ...props
}) {
  const value = _.get(formikProps?.values, name, "");

  return (
    <>
      {!readOnly && (
        <FormTextArea
          className={className}
          formikProps={formikProps}
          inputClassName={cn(
            inputClassName,
            isDisabled
              ? "tw:pointer-events-none tw:border-stroke-tertiary! tw:bg-fill-senary! tw:text-text-quinary! tw:select-none"
              : "",
          )}
          name={name}
          readOnly={isDisabled}
          resize={resize}
          testId={testId}
          {...props}
        />
      )}

      {readOnly && (
        <FormFieldContainer className={className} {...props}>
          <Text className="AdvancedCareActivityForm-text_area_read_only" testId={testId}>
            {value ? (
              // Color matches other legacy components
              <span className="tw:text-[#212529]">{value}</span>
            ) : (
              <span className="tw:text-text-quaternary">—</span>
            )}
          </Text>
        </FormFieldContainer>
      )}
    </>
  );
}
